import React, { useEffect, useState } from "react";
import { useError } from "../../../contexts/ErrorContext";
import useApi from "../../../hooks/useGaneshApi";

import {
  GridColDef,
  GridInitialState,
  GridRenderCellParams,
} from "@mui/x-data-grid-premium";
import { Link } from "react-router-dom";
import { BrandParent_T } from "../../../types/Brand";
import { renderNumberCell } from "utils/dataGrid";
import GaneshDataGrid from "../../DataGrid/GaneshDataGrid";

interface ParentBrandsbyBrandTableProps {
  brand_id: string;
}

const defaultGridState: GridInitialState = {
  filter: {
    filterModel: {
      items: [],
    },
  },
  sorting: { sortModel: [{ field: "parent_brand_id", sort: "asc" }] },
  pagination: { paginationModel: { pageSize: 25, page: 0 } },
  pinnedColumns: { left: [] },
  columns: { columnVisibilityModel: {} },
  density: "compact",
};

const columns_def: GridColDef[] = [
  {
    field: "parent_brand_id",
    headerName: "Parent Brand Id",
    description: "Brand with a parent relatiopship with the brand of interest",
    type: "string",
    width: 100,
  },
  {
    field: "parent_brand_name",
    headerName: "Parent Brand Name",
    description: "Name of the brand with parent relationship",
    type: "string",
    width: 200,
    renderCell: (params: GridRenderCellParams) => (
      <Link to={`/data-ops/brand/${params.row.parent_brand_id}`}>
        {params.value}
      </Link>
    ),
  },
  {
    field: "count_of_children",
    headerName: "Count Of Children Brands",
    description:
      "The total number of Brands in the database with a parent-child relationship to this brand",
    type: "number",
    width: 150,
    renderCell: renderNumberCell,
  },
  {
    field: "children_names",
    headerName: "Children Brand Names",
    description: "The name of the brands with a parent-child relationship",
    type: "string",
    width: 500,
  },
];

const ParentBrandsbyBrandTable: React.FC<ParentBrandsbyBrandTableProps> = ({
  brand_id,
}) => {
  const [ParentBrandsbyBrandData, setParentBrandsbyBrandData] = useState<
    BrandParent_T[]
  >([]);
  const [loading, setLoading] = useState(true);

  const { showError } = useError();
  const { apiRequest } = useApi();

  useEffect(() => {
    if (brand_id) {
      const fetchParentBrandsbyBrandData = async () => {
        try {
          const response = await apiRequest<BrandParent_T[]>(
            `/brand_reports/parent_brands/${brand_id}`,
            {
              method: "GET",
            }
          );
          if (response.data) {
            setParentBrandsbyBrandData(response.data);
          }
        } catch (error) {
          console.error(error);
          showError(`Failed to fetch Parent brand for ${brand_id}.`);
        } finally {
          setLoading(false);
        }
      };
      fetchParentBrandsbyBrandData();
    }
  }, [brand_id]);

  return (
    <GaneshDataGrid
      loading={loading}
      data={ParentBrandsbyBrandData}
      columns={columns_def}
      gridId="ParentBrandsbyBrandGrid"
      defaultGridState={defaultGridState}
      headerFilters={false}
      customHeight="400px"
    />
  );
};

export default ParentBrandsbyBrandTable;
